export const popularAnime = {
    '.popular-anime-component': {
        '.zig-zag .slick-track': {
            '>.slick-slide:nth-of-type(odd)': {
                '.image-with-text .vertical-stack': {
                    clipPath: 'polygon(0 0, 100% 0, 95% 100%, 5% 100%)'
                }
            },
            '>.slick-slide:nth-of-type(even)': {
                '.image-with-text .vertical-stack': {
                    marginTop: '12px',
                    clipPath: 'polygon(5% 0, 95% 0, 100% 100%, 0 100%)'
                }
            },
            '>.slick-slide:first-of-type': {
                '.image-with-text .vertical-stack': {
                    clipPath: 'polygon(0 0, 100% 0, 95% 100%, 0 100%)',

                    '.bottomImage': {
                        padding: '20px 28px 20px 20px'
                    }
                }
            },
            '>.slick-slide:last-child': {
                '.image-with-text .vertical-stack': {
                    clipPath: 'polygon(5% 0, 100% 0, 100% 100%, 0 100%)'
                }
            },
            '.slick-slide': {
                margin: '2px'
            }
        },
        '.slick-list': {
            overflow: 'hidden'
        },
        '.slick-track': {
            display: 'flex'
        },
        '.slick-arrow': {
            top: {base: '7%'}
        },
        '.slick-slide': {
            margin: '8px'
        },
        '.slick-arrow.slick-disabled': {
            opacity: '0.5'
        },
        '.arrow': {
            position: 'absolute'
        }
    }
}
